import { defineMessages } from "react-intl";

import { node as anesthesiologistOpinion } from "src/modules/htx/forms/comorbidities/anesthesiologistOpinion";
import { node as diabetologistOpinion } from "src/modules/htx/forms/comorbidities/diabetologistOpinion";
import { node as endocrinologistOpinion } from "src/modules/htx/forms/comorbidities/endocrinologistOpinion";
import { node as gastroenterologistOpinion } from "src/modules/htx/forms/comorbidities/gastroenterologistOpinion";
import { node as geneticistOpinion } from "src/modules/htx/forms/comorbidities/geneticistOpinion";
import { node as hematologistOpinion } from "src/modules/htx/forms/comorbidities/hematologistOpinion";
import { node as hepatologistOpinion } from "src/modules/htx/forms/comorbidities/hepatologistOpinion";
import { node as immunologistOpinion } from "src/modules/htx/forms/comorbidities/immunologistOpinion";
import { node as infectologistOpinion } from "src/modules/htx/forms/comorbidities/infectologistOpinion";
import { node as nephrologistOpinion } from "src/modules/htx/forms/comorbidities/nephrologistOpinion";
import { node as neurologistOpinion } from "src/modules/htx/forms/comorbidities/neurologistOpinion";
import { node as oncologistOpinion } from "src/modules/htx/forms/comorbidities/oncologistOpinion";
import { node as radiologistOpinion } from "src/modules/htx/forms/comorbidities/radiologistOpinion";
import { node as rheumatologistOpinion } from "src/modules/htx/forms/comorbidities/rheumatologistOpinion";
import { node as vascularSurgeonOpinion } from "src/modules/htx/forms/comorbidities/vascularSurgeonOpinion";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.comorbidities",
		defaultMessage: "Társbetegségek"
	}
});

export const node: ParentNode = {
	id: "comorbidities",
	value: { type: "wizard", title: messages.title },
	children: [
		infectologistOpinion,
		anesthesiologistOpinion,
		vascularSurgeonOpinion,
		neurologistOpinion,
		rheumatologistOpinion,
		nephrologistOpinion,
		endocrinologistOpinion,
		immunologistOpinion,
		diabetologistOpinion,
		oncologistOpinion,
		geneticistOpinion,
		hematologistOpinion,
		radiologistOpinion,
		gastroenterologistOpinion,
		hepatologistOpinion
	]
};
